module.exports = __webpack_public_path__ + "img/ic24Birthday.4b9956aa.svg";